module.exports = __webpack_public_path__ + "static/media/2v2-chaos-golf-step2.92546590.png";